angular
  .module('contrast.factory.role', [])
  .factory('RoleFactory', function ($http) {
    return {
      getRoles: function () {
        // do not require orgUuid
        return $http.get('/Contrast/api/ng/roles').then(function (response) {
          var data = response.data
          // remove `rbac_controlled` group
          var groups = data.groups.filter(function (group) {
            return !group.name.includes('rbac_controlled')
          })
          var cleanData = Object.assign({}, data, { groups })
          return { data: cleanData }
        })
      }
    }
  })
